/* ufp-lp-fire-pits.js: /pages/fire-pits lander only, Scaled Marketing.
   "Pick Your Size" (sections/ufp-lp-fire-pits-sizes.liquid). Vanilla, deferred, runs once.
   One picked size, kept in step everywhere:
   - a size tab under the drawing, a "one size up" link, a hero size pill or a swipe of the card row picks a size;
   - the pick checks the hero's size radio, so ufp-lp.js announces it (ufp:size) and the hero button, the sticky
     bar, the extras and the closing band follow;
   - here, the drawing fills that bowl in and shows its numbers, the tab lights up, and the card row slides to
     that card (sideways only: a hero pill never pulls the page down; a tab scrolls the page just enough to bring
     the cards into view).
   Desktop (cards in a grid): hover or keyboard focus on a card previews its size in the drawing.
   The page works fully without this file (tabs are anchors, the row scrolls by hand, prices are server-rendered). */
(function () {
  'use strict';
  if (window.ufpLpFirePits) return;
  window.ufpLpFirePits = { v: 2 };

  var doc = document;
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function mq(q) { try { return window.matchMedia(q); } catch (e) { return { matches: false }; } }
  var fine = mq('(hover: hover) and (pointer: fine)');

  function bind(root) {
    if (!root || root.hasAttribute('data-ufp-b-fps')) return;
    root.setAttribute('data-ufp-b-fps', '');
    var rings = $$(root, '[data-ufp-fp-ring]');
    var facts = $$(root, '[data-ufp-fp-fact]');
    var cards = $$(root, '[data-ufp-fp-card]');
    var car = root.querySelector('[data-ufp-carousel]');
    var tabs = root.querySelector('.ufp-lp-fps__tabs');
    if (!cards.length) return;
    var picked = null, hover = null, last = null, first = true;
    /* wide screens have room beside the drawing: the hose tip starts open there */
    var tip = root.querySelector('.ufp-lp-fps__tip');
    if (tip && mq('(min-width: 990px)').matches) tip.open = true;

    function has(k) { return cards.some(function (c) { return c.getAttribute('data-ufp-fp-card') === k; }); }
    function paint() {
      var k = hover || picked || '';
      if (k === last) return;
      last = k;
      rings.forEach(function (r) {
        var on = r.getAttribute('data-ufp-fp-ring') === k;
        r.classList.toggle('ufp-lp-is-active', on);
        if (r.tagName === 'A') { if (on) r.setAttribute('aria-current', 'true'); else r.removeAttribute('aria-current'); }
      });
      facts.forEach(function (f) { f.hidden = f.getAttribute('data-ufp-fp-fact') !== k; });
      cards.forEach(function (c) { c.classList.toggle('ufp-lp-is-active', c.getAttribute('data-ufp-fp-card') === (picked || '')); });
    }
    function slideTo(k, instant) {
      var U = window.ufpLp, api = U && U.carousel && U.carousel(car);
      if (api) api.go(String(k), instant);
    }
    /* A pick made here goes through the hero's size radio when the page has one, so every listener hears one
       event. The hero writes #size-KEY to the address bar. */
    function pick(k) {
      k = String(k);
      if (!has(k)) return;
      var radio = doc.querySelector('[data-ufp-size-radio][data-key="' + k.replace(/"/g, '') + '"]');
      if (radio) {
        if (!radio.checked) { radio.checked = true; try { radio.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {} } else onSize({ detail: { key: k } });
      } else onSize({ detail: { key: k } });
    }
    function onSize(e) {
      var d = e && e.detail;
      if (!d || !d.key || !has(String(d.key))) return;
      picked = String(d.key);
      paint();
      slideTo(picked, first);
      first = false;
    }

    /* tabs and "one size up" links */
    root.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-ufp-fp-go]') : null;
      if (!a || !root.contains(a)) return;
      var k = a.getAttribute('data-ufp-fp-go');
      if (!has(k)) return;
      e.preventDefault();
      pick(k);
      // bring the cards into view when the tapped tab sits well above them
      if (car && a.classList.contains('ufp-lp-fps__tab')) {
        var vh = window.innerHeight || doc.documentElement.clientHeight;
        var top = car.getBoundingClientRect().top;
        var U = window.ufpLp;
        if (top > vh - 220 && U && U.scrollToEl) U.scrollToEl(tabs || car);
      }
    });

    /* swipe: the card that comes to rest in view becomes the pick */
    if (car) car.addEventListener('ufp:slide', function (e) {
      var d = e.detail || {};
      if (d.user && d.key && String(d.key) !== picked) pick(d.key);
    });

    /* desktop grid: hover or focus on a card previews it in the drawing */
    cards.forEach(function (c) {
      var k = c.getAttribute('data-ufp-fp-card');
      c.addEventListener('mouseenter', function () { if (fine.matches) { hover = k; paint(); } });
      c.addEventListener('mouseleave', function () { if (hover === k) { hover = null; paint(); } });
      c.addEventListener('focusin', function () { if (fine.matches) { hover = k; paint(); } });
      c.addEventListener('focusout', function () {
        setTimeout(function () { if (hover === k && !c.contains(doc.activeElement)) { hover = null; paint(); } }, 0);
      });
    });

    doc.addEventListener('ufp:size', onSize);
    var U = window.ufpLp;
    if (U && U.last && U.last['ufp:size']) onSize({ detail: U.last['ufp:size'] });
    else {
      var def = rings.filter(function (r) { return r.classList.contains('ufp-lp-is-active'); })[0];
      if (def) { picked = def.getAttribute('data-ufp-fp-ring'); last = picked; first = false; }
    }
  }

  function init(scope) { $$(scope || doc, '[data-ufp-fps]').forEach(bind); if (scope && scope.hasAttribute && scope.hasAttribute('data-ufp-fps')) bind(scope); }
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);
})();
